window.WhatsNewPage = class {
	constructor() {
		this.loading = false;
		this.reachedEnd = false;
		this.selector = '.posts-navigation-area';
		this.navigationElm = document.querySelector(this.selector);
		if (!this.navigationElm) return;
		this.navigationElm.classList.add('js-enabled');
		this.intersectionObserver.observe(this.navigationElm);
	}

	makeRequest(type, url, data, callback) {
		const classInstance = this;
		const newXHR = new XMLHttpRequest() || new window.ActiveXObject('Microsoft.XMLHTTP');
		newXHR.open(type, url, true);
		newXHR.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		newXHR.send('json=true');
		newXHR.onreadystatechange = function () {
			if (200 === this.status && 3 < this.readyState) {
				callback(classInstance, this.response);
			}
		};
	}

	appendPosts(classInstance, response) {
		if (!response) return;
		response = JSON.parse(response);
		if (response.next_link) {
			classInstance.navigationElm.innerHTML = response.next_link;
		} else {
			classInstance.reachedEnd = true;
			classInstance.navigationElm.querySelector('a.btn').remove();
		}
		const parser = new DOMParser();
		const parsedHTML = parser.parseFromString(response.html, 'text/html');
		const posts = parsedHTML.querySelectorAll('.grid .posts-card-holder');
		if (!posts.length) return;
		[].forEach.call(posts, function (post, index) {
			post.classList.add('fade-in');
			post.style.setProperty('--animation-delay', index * 100 + 'ms');
			document.querySelector('.posts-page-section:last-of-type .container .grid').appendChild(post);
		});
		setTimeout(
			() => {
				classInstance.loading = false;
			},
			300 + posts.length * 100,
		);
		classInstance.loading = false;
	}

	intersectionObserver = new IntersectionObserver((entries) => {
		if (this.loading || this.reachedEnd || entries[0].intersectionRatio <= 0) return;
		this.loading = true;
		const nextPage = this.navigationElm.querySelector('a.btn');
		if (!nextPage) return;
		const nextPageUrl = nextPage.href;
		this.makeRequest('POST', nextPageUrl, JSON.stringify({ json: true }), this.appendPosts);
	});
};
